import { Dropdown, Menu } from 'antd';
import { useTranslate } from '@tolgee/react';
import { DownOutlined } from '@ant-design/icons';
import {
  useAutoTranslateConfig,
  useSetAutoTranslateConfig,
} from 'hooks/business/im/chatPreference';

interface SendButtonProps {
  translating: boolean;
  sendBtnDisable: boolean;
  doSend: () => void;
}

export const SendButton = (props: SendButtonProps) => {
  const { translating, sendBtnDisable, doSend } = props;
  const autoTranslate = useAutoTranslateConfig();
  const setAutoTranslate = useSetAutoTranslateConfig();
  const { t } = useTranslate();

  return (
    <Dropdown.Button
      loading={autoTranslate && translating}
      disabled={sendBtnDisable}
      onClick={doSend}
      type="primary"
      icon={<DownOutlined />}
      trigger={['click']}
      overlay={
        <Menu
          selectedKeys={[autoTranslate ? '2' : '1']}
          onClick={({ key }) => {
            setAutoTranslate(key === '2');
          }}
        >
          <Menu.Item key="1">{t('ViewsChat.直接发送')}</Menu.Item>
          <Menu.Item key="2">{t('ViewsChat.翻译后发送')}</Menu.Item>
        </Menu>
      }
    >
      {autoTranslate ? t('ViewsChat.翻译后发送') : t('ViewsChat.直接发送')}
    </Dropdown.Button>
  );
};
